import { useQuery } from "@tanstack/react-query";

import { getDigitalAgronomistCropsRecommendation } from "services";

import { GET_DIGITAL_AGRONOMIST_PREFERENCES } from "consts";

import { CropRecommendationResponse, User } from "models";

export const useGetDigitalAgronomistPreferences = ({ user }: { user: User | null }) =>
  useQuery<CropRecommendationResponse | null>({
    queryKey: [GET_DIGITAL_AGRONOMIST_PREFERENCES, user],
    queryFn: ({ signal }) => {
      if (!user) return null;
      return getDigitalAgronomistCropsRecommendation({ signal });
    },
  });
